var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWebsiteBug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5e8fe"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.907,
    x2: 404.713,
    xlinkHref: "#lg1",
    y1: 177.766,
    y2: 464.571
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.442,
    x2: 259.282,
    y1: 125.138,
    y2: 244.982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2e3"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff637b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e63950"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.241,
    x2: 46.622,
    xlinkHref: "#lg2",
    y1: 167.478,
    y2: 178.435
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.372,
    x2: 86.753,
    y1: 167.478,
    y2: 178.435
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbf00"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.358,
    x2: 142.441,
    y1: 162.5,
    y2: 196.583
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9dd39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b799d"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 452.035,
    y2: 551.03
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2428,
    stopColor: "#93cef6",
    stopOpacity: 0.243
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5763,
    stopColor: "#6abfec",
    stopOpacity: 0.576
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    stopColor: "#51b5e5",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2e3"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.249,
    x2: 296.249,
    y1: 293.451,
    y2: 86.451
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07485e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3332,
    stopColor: "#063f52",
    stopOpacity: 0.333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#032632",
    stopOpacity: 0.936
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03232e"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.028,
    x2: 126.954,
    y1: 529.235,
    y2: 252.161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07485e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2965,
    stopColor: "#07455a",
    stopOpacity: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5772,
    stopColor: "#063c4f",
    stopOpacity: 0.577
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8508,
    stopColor: "#042e3c",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03232e"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c50000"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.034,
    x2: 216.824,
    xlinkHref: "#lg3",
    y1: 431.949,
    y2: 431.949
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.034,
    x2: 216.824,
    xlinkHref: "#lg3",
    y1: 328.465,
    y2: 328.465
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.701,
    x2: 216.824,
    xlinkHref: "#lg3",
    y1: 389.382,
    y2: 389.382
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.176,
    x2: 357.967,
    xlinkHref: "#lg3",
    y1: 431.949,
    y2: 431.949
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.176,
    x2: 357.967,
    xlinkHref: "#lg3",
    y1: 328.465,
    y2: 328.465
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.176,
    x2: 369.299,
    xlinkHref: "#lg3",
    y1: 389.382,
    y2: 389.382
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.187,
    x2: 298.813,
    xlinkHref: "#lg3",
    y1: 280.848,
    y2: 280.848
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.511,
    x2: 304.479,
    xlinkHref: "#lg2",
    y1: 317.411,
    y2: 402.824
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.504,
    x2: 260.84,
    xlinkHref: "#lg2",
    y1: 361.05,
    y2: 416.386
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.583,
    x2: 319.051,
    xlinkHref: "#lg2",
    y1: 360.739,
    y2: 416.207
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.944,
    x2: 87.149,
    xlinkHref: "#lg2",
    y1: 242.248,
    y2: 276.453
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.611,
    x2: 473.816,
    xlinkHref: "#lg2",
    y1: 354.64,
    y2: 388.845
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.588,
    x2: 114.861,
    xlinkHref: "#lg2",
    y1: 301.091,
    y2: 314.365
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 471.396,
    x2: 484.669,
    xlinkHref: "#lg2",
    y1: 312.325,
    y2: 325.599
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.295,
    x2: 104.403,
    xlinkHref: "#lg2",
    y1: 438.849,
    y2: 464.958
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.567,
    x2: 424.84,
    xlinkHref: "#lg2",
    y1: 229.49,
    y2: 242.764
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.599,
    x2: 314.407,
    y1: 74.85,
    y2: 189.658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e63950"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63950",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0467,
    stopColor: "#e4354b",
    stopOpacity: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4669,
    stopColor: "#d31822",
    stopOpacity: 0.467
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7991,
    stopColor: "#c90709",
    stopOpacity: 0.799
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c50000"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.439,
    x2: 206.468,
    xlinkHref: "#lg4",
    y1: 162.048,
    y2: 79.737
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.052,
    x2: 238.614,
    xlinkHref: "#lg4",
    y1: 243.249,
    y2: 200.138
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.751,
    x2: 275.249,
    xlinkHref: "#lg1",
    y1: 130.251,
    y2: 130.251
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m490.588 498.861h-471.176c-10.721 0-19.412-8.691-19.412-19.412v-329.182c0-10.721 8.691-19.412 19.412-19.412h471.176c10.721 0 19.412 8.691 19.412 19.412v329.182c0 10.721-8.691 19.412-19.412 19.412z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 209.43h-510v-59.163c0-10.721 8.691-19.412 19.412-19.412h471.176c10.721 0 19.412 8.691 19.412 19.412z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40.853 185.88h-10.229c-5.867 0-10.623-4.756-10.623-10.623v-10.229c0-5.867 4.756-10.623 10.623-10.623h10.229c5.867 0 10.623 4.756 10.623 10.623v10.229c0 5.867-4.756 10.623-10.623 10.623z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.984 185.88h-10.23c-5.867 0-10.623-4.756-10.623-10.623v-10.229c0-5.867 4.756-10.623 10.623-10.623h10.229c5.867 0 10.623 4.756 10.623 10.623v10.229c.001 5.867-4.755 10.623-10.622 10.623z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.115 185.88h-10.229c-5.867 0-10.623-4.756-10.623-10.623v-10.229c0-5.867 4.756-10.623 10.623-10.623h10.229c5.867 0 10.623 4.756 10.623 10.623v10.229c0 5.867-4.756 10.623-10.623 10.623z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 409.351v70.099c0 10.721 8.691 19.412 19.412 19.412h471.176c10.721 0 19.412-8.691 19.412-19.412v-70.099z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#b5dbff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m166.113 416.236h-104.397c-7.252 0-13.131-5.879-13.131-13.131v-126.207c0-7.252 5.879-13.131 13.131-13.131h104.397c7.252 0 13.131 5.879 13.131 13.131v126.206c.001 7.253-5.878 13.132-13.131 13.132z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m286.513 301.767h-71.598c-5.247 0-9.5-4.253-9.5-9.5v-19c0-5.247 4.253-9.5 9.5-9.5h71.598c5.247 0 9.5 4.253 9.5 9.5v19c0 5.246-4.253 9.5-9.5 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.915 301.767h-125c-5.247 0-9.5-4.253-9.5-9.5v-19c0-5.247 4.253-9.5 9.5-9.5h125c5.247 0 9.5 4.253 9.5 9.5v19c0 5.246-4.253 9.5-9.5 9.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m380.317 359.001h71.598c5.247 0 9.5-4.253 9.5-9.5v-19c0-5.247-4.253-9.5-9.5-9.5h-71.598c-5.247 0-9.5 4.253-9.5 9.5v19c0 5.247 4.253 9.5 9.5 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.915 359.001h125c5.247 0 9.5-4.253 9.5-9.5v-19c0-5.247-4.253-9.5-9.5-9.5h-125c-5.247 0-9.5 4.253-9.5 9.5v19c0 5.247 4.253 9.5 9.5 9.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m286.513 416.236h-71.598c-5.247 0-9.5-4.253-9.5-9.5v-19c0-5.247 4.253-9.5 9.5-9.5h71.598c5.247 0 9.5 4.253 9.5 9.5v19c0 5.246-4.253 9.5-9.5 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.915 416.236h-125c-5.247 0-9.5-4.253-9.5-9.5v-19c0-5.247 4.253-9.5 9.5-9.5h125c5.247 0 9.5 4.253 9.5 9.5v19c0 5.246-4.253 9.5-9.5 9.5z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m490.588 130.855h-352.69c.148 34.277 12.819 65.123 36.142 86.745l281.253 281.261h35.295c10.721 0 19.412-8.691 19.412-19.412v-329.182c0-10.721-8.691-19.412-19.412-19.412z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 479.449v-22.838l-153.153-153.152c-1.741-3.497-5.342-5.905-9.513-5.905-1.525 0-2.972.327-4.283.905-.688-.604-1.453-1.119-2.281-1.531l-43.076-43.076c-1.741-3.497-5.342-5.905-9.513-5.905-5.872 0-10.632 4.76-10.632 10.632 0 10.572-3.42 20.192-8.648 26.465-2.132-.401-4.302-.69-6.5-.88-.706-.631-1.495-1.169-2.351-1.595l-28.717-28.717c-1.741-3.497-5.342-5.905-9.513-5.905-5.872 0-10.632 4.76-10.632 10.632 0 12.534 3.291 24.493 9.327 34.173-12.126 7.12-21.707 18.101-27.026 31.277l-21.308-20.569c-1.741-3.497-5.342-5.905-9.513-5.905-5.872 0-10.632 4.76-10.632 10.632 0 14.77 6.659 28.092 17.282 37.442l12.463 12.617c-.021.336-.041.672-.045 1.012-.032 3.068-.057 6.306-.069 9.483-6.817 1.38-13.133 3.333-18.64 5.82-19.424 8.771-22.324 20.811-22.324 27.207 0 4.172 2.408 7.772 5.905 9.513l13.602 13.942c-5.177 7.843-8.175 17.097-8.175 27.005 0 4.172 2.408 7.772 5.905 9.513l37.12 37.12h295.53c10.719 0 19.41-8.691 19.41-19.412z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m162.666 462.861c-5.872 0-10.632-4.76-10.632-10.632 0-28.227 24.295-51.191 54.158-51.191 5.872 0 10.632 4.76 10.632 10.632s-4.76 10.632-10.632 10.632c-18.137 0-32.893 13.425-32.893 29.926-.001 5.872-4.761 10.633-10.633 10.633z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.192 359.377c-29.863 0-54.158-22.964-54.158-51.191 0-5.872 4.76-10.632 10.632-10.632s10.632 4.76 10.632 10.632c0 16.502 14.756 29.926 32.893 29.926 5.872 0 10.632 4.76 10.632 10.632s-4.759 10.633-10.631 10.633z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.334 412.4c-5.872 0-10.632-4.76-10.632-10.632 0-6.396 2.9-18.436 22.324-27.207 11.707-5.287 27.037-8.198 43.166-8.198 5.872 0 10.632 4.76 10.632 10.632s-4.76 10.632-10.632 10.632c-12.986 0-25.529 2.301-34.415 6.314-7.341 3.315-9.811 6.763-9.811 7.827 0 5.872-4.76 10.632-10.632 10.632z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m347.334 462.861c-5.872 0-10.632-4.76-10.632-10.632 0-16.502-14.756-29.926-32.893-29.926-5.872 0-10.632-4.76-10.632-10.632s4.76-10.632 10.632-10.632c29.863 0 54.158 22.964 54.158 51.191-.001 5.87-4.761 10.631-10.633 10.631z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.808 359.377c-5.872 0-10.632-4.76-10.632-10.632s4.76-10.632 10.632-10.632c18.137 0 32.893-13.425 32.893-29.926 0-5.872 4.76-10.632 10.632-10.632s10.632 4.76 10.632 10.632c.001 28.225-24.294 51.19-54.157 51.19z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.666 412.4c-5.872 0-10.632-4.76-10.632-10.632 0-1.064-2.47-4.512-9.811-7.827-8.885-4.013-21.429-6.314-34.415-6.314-5.872 0-10.632-4.76-10.632-10.632s4.76-10.632 10.632-10.632c16.129 0 31.46 2.911 43.166 8.198 19.424 8.771 22.324 20.811 22.324 27.207.001 5.872-4.76 10.632-10.632 10.632z",
    fill: "url(#SVGID_14_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m255 313.751c-12.127 0-23.786-6.315-31.989-17.326-7.625-10.236-11.824-23.677-11.824-37.847 0-5.872 4.76-10.632 10.632-10.632s10.632 4.76 10.632 10.632c0 18.38 10.326 33.908 22.548 33.908s22.548-15.528 22.548-33.908c0-5.872 4.76-10.632 10.632-10.632s10.632 4.76 10.632 10.632c0 14.17-4.199 27.611-11.824 37.847-8.201 11.011-19.86 17.326-31.987 17.326z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m321.127 346.274c-.869-34.595-29.201-62.155-63.807-62.358-1.547-.009-3.094-.009-4.641 0-34.606.204-62.937 27.763-63.807 62.358-.279 11.113-.279 22.225 0 33.337.869 34.595 29.201 62.154 63.807 62.358 1.547.009 3.094.009 4.641 0 34.606-.204 62.938-27.763 63.807-62.358.279-11.112.279-22.225 0-33.337z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.748 340.431c-9.615 1.053-16.913 9.155-17.014 18.826-.09 8.677-.124 18.72.031 24.888.53 21.106 11.07 39.847 26.836 52.462 18.69 14.954 46.399 1.477 46.399-22.459v-76.715c-19.577 0-38.464 1.05-56.252 2.998z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.252 340.431c9.615 1.053 16.913 9.155 17.014 18.826.09 8.677.124 18.72-.031 24.888-.53 21.106-11.07 39.847-26.836 52.462-18.69 14.954-46.399 1.477-46.399-22.459v-76.715c19.577 0 38.464 1.05 56.252 2.998z",
    fill: "url(#SVGID_18_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m93.075 279.267h-56.816c-8.979 0-16.258-7.279-16.258-16.258v-18.076c0-8.979 7.279-16.258 16.258-16.258h56.816c8.979 0 16.258 7.279 16.258 16.258v18.076c0 8.979-7.279 16.258-16.258 16.258z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.742 391.659h-56.816c-8.979 0-16.258-7.279-16.258-16.258v-18.076c0-8.979 7.279-16.258 16.258-16.258h56.816c8.979 0 16.258 7.279 16.258 16.258v18.076c0 8.979-7.279 16.258-16.258 16.258z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.096 320.17h-9.919c-5.286 0-9.571-4.285-9.571-9.571v-9.919c0-5.286 4.285-9.571 9.571-9.571h9.919c5.286 0 9.571 4.285 9.571 9.571v9.919c0 5.286-4.285 9.571-9.571 9.571z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.904 331.404h-9.919c-5.286 0-9.571-4.285-9.571-9.571v-9.919c0-5.286 4.285-9.571 9.571-9.571h9.919c5.286 0 9.571 4.285 9.571 9.571v9.919c0 5.287-4.285 9.571-9.571 9.571z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.879 463.901h-51.272c-5.858 0-10.607-4.749-10.607-10.607v-10.993c0-5.858 4.749-10.607 10.607-10.607h51.272c5.858 0 10.607 4.749 10.607 10.607v10.993c0 5.858-4.749 10.607-10.607 10.607z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.075 248.569h-9.919c-5.286 0-9.571-4.285-9.571-9.571v-9.919c0-5.286 4.285-9.571 9.571-9.571h9.919c5.286 0 9.571 4.285 9.571 9.571v9.919c0 5.287-4.285 9.571-9.571 9.571z",
    fill: "url(#SVGID_24_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 130.251,
    fill: "url(#SVGID_25_)",
    r: 119.112
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.513 142.247-102.52-102.521c-3.407-4.547-9.423-5.014-16.125-5.014-10.852 0-17.321 3.822-17.321 14.145 0 31.498 3.706 76.762 3.706 108.26 0 4.117-.2 7.034 2.663 8.919l68.56 68.56c33.433-18.455 57.053-52.507 61.037-92.349z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.349 235.212-41.405-41.405c-3.719-4.136-9.032-5.779-14.812-5.779-11.647 0-19.381 8.264-19.381 19.381 0 5.927 1.617 11.445 5.878 15.246l26.036 26.036c15.668-1.655 30.429-6.348 43.684-13.479z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m275.249 207.41c0 10.853-9.264 20.382-20.117 20.382-11.647 0-20.382-9.529-20.382-20.382 0-11.117 8.735-20.382 20.382-20.382 10.853 0 20.117 9.265 20.117 20.382zm-5.029-50.293c0 8.206-9 11.647-15.353 11.647-8.47 0-15.617-3.441-15.617-11.647 0-31.498-3.706-76.762-3.706-108.26 0-10.323 8.47-16.147 19.323-16.147 10.323 0 19.058 5.823 19.058 16.147.001 31.498-3.705 76.762-3.705 108.26z",
    fill: "url(#SVGID_28_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebsiteBug);
export default __webpack_public_path__ + "static/media/icon-website-bug.5fe2c1163c650e319cf03c94b201d1e5.svg";
export { ForwardRef as ReactComponent };